<!--
	* @Description: 职务 详情
	* @Author: ZSC
	* @Date: 2023-05-04 16:52:13.51
 * @LastEditors: wanglixin wang1223634360@163.com
 * @LastEditTime: 2023-05-06 15:42:07
-->
<template>
	<div>
		<el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
			<template #header>
				<div class="header-left">
					<el-icon class="header-icon"><Document /></el-icon>
					<span class="header-title">详情</span>
				</div>
				<div class="header-right">
					<el-button type="info" text @click="closeWindow('openDetail', emits, false)">
						<el-icon><Close /></el-icon>
					</el-button>
				</div>
			</template>
			<el-descriptions :column="2" border>
				<el-descriptions-item label="职务名称" label-align="right" align="left" width="120px" span="2">{{ruleForm.zwmc}}</el-descriptions-item>
				<el-descriptions-item label="职务代码" label-align="right" align="left" width="120px" span="2">{{ruleForm.zwdm}}</el-descriptions-item>
				<el-descriptions-item label="职务等级" label-align="right" align="left" width="120px" span="2">{{ruleForm.zwdjmc}}</el-descriptions-item>
				<el-descriptions-item label="备注" label-align="right" align="left" width="120px" span="2">{{ruleForm.bz}}</el-descriptions-item>
				<!-- <el-descriptions-item label="是否有效" label-align="right" align="left" width="120px" span="2">
          <span v-if="ruleForm.sfyx===true">是</span>
          <span v-if="ruleForm.sfyx===false">否</span>
        </el-descriptions-item> -->
				<el-descriptions-item label="是否允许二次分配权限" label-align="right" align="left" width="120px" span="2">
          <span v-if="ruleForm.sfyxecfpqx===true">是</span>
          <span v-if="ruleForm.sfyxecfpqx===false">否</span>
        </el-descriptions-item>
				<el-descriptions-item label="是否系统默认" label-align="right" align="left" width="120px" span="2">
          <span v-if="ruleForm.sfxtmr===true">是</span>
          <span v-if="ruleForm.sfxtmr===false">否</span>
        </el-descriptions-item>
			</el-descriptions>
			<template #footer>
				<div class="dialog-footer">
					<div></div>
					<div class="footer_but">
						<el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
					</div>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({ openDetail: { type: Boolean, required: true }, row: { type: Object, required: false } })
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/pdp/zhiwu/' + props.row.id,
        ruleForm,
        loadSuccess: function (res) {

        }
      })
    }
  }, { deep: true, immediate: true })
</script>
